let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("68QRq")).then(() => parcelRequire('bA0VC'));